import { useCallback, useEffect, useState } from 'react';
import {
  normalizeScoresResponse,
  sortScoresByUpdatedAt,
} from '../utils/scoreUtils';
import { buildApiUrl } from '../lib/api';

export function useScores({ userId, refreshKey = 0 } = {}) {
  const [scores, setScores] = useState([]);
  const [loading, setLoading] = useState(Boolean(userId));

  const fetchScores = useCallback(async () => {
    if (!userId) {
      setScores([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(
        `${buildApiUrl('/get-scores')}?userId=${encodeURIComponent(
          userId
        )}`
      );
      const data = await response.json().catch(() => ({}));
      const normalized = normalizeScoresResponse(data);
      const sorted = sortScoresByUpdatedAt(normalized);
      setScores(sorted);
    } catch (error) {
      console.error('Failed to fetch scores:', error);
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    if (!userId) {
      setScores([]);
      setLoading(false);
      return;
    }
    fetchScores();
  }, [fetchScores, refreshKey, userId]);

  return { scores, setScores, loading, refetch: fetchScores };
}
